import { Component } from '@angular/core';
import { UntypedFormGroup, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BudgetReassignmentViewModalComponent } from './budget-reassignment-view-modal/budget-reassignment-view-modal.component';
import { NewBudgetViewModalComponent } from './new-budget-view-modal/new-budget-view-modal.component';
import { AdministrationSummaryService } from '../../services/administration/administration-summary.service';
import { CommonService } from '../../services/common.service';
import { DeleteBoxComponent } from '../../common/delete-box/delete-box.component';

@Component({
  selector: 'app-budget-summary',
  templateUrl: './budget-summary.component.html',
  styleUrl: './budget-summary.component.scss'
})
export class BudgetSummaryComponent {
  columnDefs;
  BudgetassignmentFormSearch: FormGroup;
  collapesedOrNot: boolean;
  rowData: any[] = [];
  operations: any[] = [];
  tempoperation: any[] = [];
  ModulesListDropDown: any[] = [];
  YearsListDropDown: any[] = [{ label: "All", value: "0" }];
  haveAddPermission: boolean = false;
  EffectiveBudgetListDropDown = [
    { label: "All", value: 0 },
    { label: "Inactive", value: 1 },
    { label: "Active", value: 2 },
    { label: "On-hold", value: 3 },
    { label: "Closed", value: 4 },
  ];
  constructor(private modalService: NgbModal,
    private summaryService: AdministrationSummaryService,
    private commonService: CommonService,
    private fb: FormBuilder) { }
  ngOnInit() {
    this.BudgetassignmentFormSearch = this.fb.group({
      ID: [],
      MODULE_ID: [""],
      PROGRAM_CODE: [""],
      TIMELINE_VALUE: ['0'],
      BUDGET_STATUS: [0],
      CUSTOM_START_DATE: [null],
      CUSTOM_END_DATE: [null],
      StartDate_DATEO: [null],
      EndDate_DATEO: [null]
    });

    const currentYear = new Date().getFullYear();
    const years: number[] = [];
    for (let i = currentYear - 5; i <= currentYear + 5; i++) {
      this.YearsListDropDown.push({ label: i + "", value: i + "" });
    }
    this.GetMasterData();
    this.collapesedOrNot = false;
    this.columnDefs = [
      {
        "headerName": "Years/Dates",
        "field": "TIMELINE_VALUEStr"
      },
      {
        "headerName": "Program",
        "field": "MODULE_NAME"
      },
      {
        "headerName": "Grant type",
        "field": "SUB_PROGRAM_NAME"
      },
      {
        "headerName": "Effective",
        "field": "BUDGET_STATUSStr"
      },
      {
        "headerName": "Allocated Budget",
        "field": "ALLOCATED_AMOUNTStr"
      }
    ]

    this.tempoperation = [];
    if (this.commonService.getScreenPermission("634", "E")) {
      this.tempoperation.push({
        "name": "Edit",
        "id": "edit"
      });
    }
    if (this.commonService.getScreenPermission("634", "D")) {
      this.tempoperation.push({
        "name": "Delete",
        "id": "delete"
      });
    }
    if (this.commonService.getScreenPermission("634", "N")) {
      this.haveAddPermission=true;
    }
    this.tempoperation.push({
      "name": "Reassign",
      "id": "budgetReassignment"
    });
    this.tempoperation.push({
      "name": "View",
      "id": "view"
    });
    this.operations = this.tempoperation.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
    this.SummaryData();
  }
  DateSelect(event, type) {
    let Full_Date = {
      Day: event.getDate(),
      Month: (event.getMonth() + 1),
      Year: event.getFullYear(),
      Hours: 0,
      Minutes: 0,
      Seconds: 0,
      IsEndDate: false,
      HasValue: true,
      IsDateModified: true
    }
    if (type == "start")
      this.BudgetassignmentFormSearch.controls["StartDate_DATEO"].setValue(Full_Date);
    else
      this.BudgetassignmentFormSearch.controls["EndDate_DATEO"].setValue(Full_Date);
  }
  GetMasterData() {
    this.summaryService.GetData("api/BudgetAssignment/GetMasterData/-1/-1").subscribe({
      next: (result) => {
        if (result.Status == 0) {
          this.ModulesListDropDown = [{ label: "Select", value: "" }].concat(result.Data["MasterData1"]);
        }
      },
      error: () => {

      },
    })
  }
  SummaryData() {
    this.summaryService.GetData("api/BudgetAssignment/Summary").subscribe(summary => {
      if (summary.Status == 0) {
        this.rowData = summary.Data;
      }
    });
  }
  veiwAll() {
    this.Clear();
    this.SummaryDataSearch()
  }
  Clear() {
    this.BudgetassignmentFormSearch = this.fb.group({
      ID: [""],
      MODULE_ID: [""],
      PROGRAM_CODE: [""],
      TIMELINE_VALUE: ["0"],
      BUDGET_STATUS: [0],
      CUSTOM_START_DATE: [null],
      CUSTOM_END_DATE: [null],
      StartDate_DATEO: [null],
      EndDate_DATEO: [null]
    });
  }
  SummaryDataSearch() {
    const formData = this.BudgetassignmentFormSearch.getRawValue();
    this.summaryService.Insert("api/BudgetAssignment/SummarySearch", formData).subscribe(summary => {
      if (summary.Status == 0) {
        this.rowData = summary.Data;
      }
    });
  }
  onCallbackOperation($event) {

  }
  onRowDoubleClicked($event) {

  }
  onSetGridApi($event) {

  }
  onSelectionChanged($event) {

  }
  Add() {
    const Modalref = this.modalService.open(NewBudgetViewModalComponent, {
      backdrop: false,
      keyboard: false,
      animation: true,
      windowClass: 'modal-vlg right modal-right'
    });

    Modalref.componentInstance.Content = {
      heading: "New",
      ID: "",
      MODULE_ID: "",
      PROGRAM_CODE:"",
    }
    Modalref.result.then((result) => {
      this.SummaryData();
    });
  }
  edit(data) {
    const Modalref = this['self'].modalService.open(NewBudgetViewModalComponent, {
      backdrop: false,
      keyboard: false,
      animation: true,
      windowClass: 'modal-vlg right modal-right'
    });

    Modalref.componentInstance.Content = {
      heading: "Edit",
      ID: data.ID,
      MODULE_ID: data.MODULE_ID,
      PROGRAM_CODE: data.PROGRAM_CODE,
    }
    Modalref.result.then((result) => {
      this['self'].SummaryData();
    });
  }
  budgetReassignment(data) {
    const Modalref = this['self'].modalService.open(BudgetReassignmentViewModalComponent, {
      backdrop: false,
      keyboard: false,
      animation: true,
      windowClass: 'modal-vlg right modal-right'
    });

    Modalref.componentInstance.Content = {
      heading: "Budget_ReAssignment",
      data: data,
      ModuleId: data.MODULE_ID

    }
    Modalref.result.then((result) => {
      this['self'].SummaryData();
    });
  }
  view(Data) {
    const Modalref = this['self'].modalService.open(NewBudgetViewModalComponent, {
      backdrop: false,
      keyboard: false,
      animation: true,
      windowClass: 'modal-vlg right modal-right'
    });

    Modalref.componentInstance.Content = {
      heading: "View",
      ID: Data.ID,
      MODULE_ID: Data.MODULE_ID,
      PROGRAM_CODE: Data.PROGRAM_CODE,
    }
    Modalref.result.then((result) => {

    });
  }
  delete(RcordData) {
    const id = RcordData['ID'];
    const dname = RcordData['BUDGET_NAME'];
    let msg = "";
    const modalRef = this['self'].modalService.open(DeleteBoxComponent, { backdrop: false })
    modalRef.componentInstance.Content = { heading: 'Delete', custommessage: 'Are you sure you want to delete' + "'" + dname + "'" + ' ?', ProceedButtonName: "Delete", TerminateButtonName: "Cancel" }
    modalRef.result.then(result => {
      if (result == "okclick") {
        this['self'].summaryService.Delete("api/BudgetAssignment/Delete?RecordID=" + id).subscribe(result => {
          if (result.Status === 0) {
            this['self'].commonService.SuccessBanner(result.Message);
            this['self'].SummaryData();
          }
          else {
            this['self'].commonService.ValidationBanner("This budget '" + dname + "' cannot be deleted as it has been linked to requests or other configurations");
          }
        });
      }
    });
  }

}
